import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import {
  Wrapper,
  HtmlContent,
} from '../common';
import {
  IllustrationCraftBits,
  IllustrationPhone,
  IllustrationPlayCracker,
} from '../illustrations';
import { convertColorToHex, toKebabCase } from '../../util/helpers';
import './HowItWorksBlock.scss';

const ILLUSTRATION_PHONE_ID = 'phone';
const ILLUSTRATION_CRAFT_BITS_ID = 'craft-bits';
const ILLUSTRATION_PLAY_CRACKER_ID = 'play-cracker';

const HowItWorksIllustration = ({ illustrationId }) => {
  switch (illustrationId) {
    case (ILLUSTRATION_PHONE_ID):
      return (
        <IllustrationPhone />
      );
    case (ILLUSTRATION_CRAFT_BITS_ID):
      return (
        <IllustrationCraftBits />
      );
    case (ILLUSTRATION_PLAY_CRACKER_ID):
      return (
        <IllustrationPlayCracker />
      );
    default:
      return null;
  }
};

const HowItWorksBlock = (props) => {
  const {
    data,
    isHome,
  } = props;
  const {
    primary,
    items: steps,
  } = data;
  const {
    sectionTheme,
    title,
  } = primary;
  const sectionHex = sectionTheme ? convertColorToHex(sectionTheme) : null;
  let ref = null;
  let inView = null;
  if (isHome) {
    const [inViewRef, inViewBool] = useInView({
      /* Optional options */
      threshold: 0.2,
    });
    ref = inViewRef;
    inView = inViewBool;
    useEffect(() => {
      if (inView) document.documentElement.style.setProperty('--bg-colour', sectionHex);
    }, [inView]);
  }
  return (
    <section className="how-it-works-block" ref={ref}>
      <Wrapper isBound>
        <h2 className="title">{title.text}</h2>
        <div className="cols steps-cols">
          { steps.map((step) => {
            const {
              title: stepTitle,
              textBody,
              illustration,
            } = step;
            return (
              <div
                className="step"
                key={toKebabCase(stepTitle.text)}
              >
                <HowItWorksIllustration illustrationId={toKebabCase(illustration)} />
                <h3 className="step-title">{stepTitle.text}</h3>
                <HtmlContent className="description" content={textBody.html} />
              </div>
            );
          })}
        </div>
      </Wrapper>
    </section>
  );
};

export default HowItWorksBlock;
